import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RekionTopPage = _resolveComponent("RekionTopPage", true)!

  return (_openBlock(), _createBlock(_component_RekionTopPage, { genres: _ctx.genres }, null, 8, ["genres"]))
}